import { render, staticRenderFns } from "./ChangePermissionModal.vue?vue&type=template&id=5ae56be2&scoped=true&"
import script from "./ChangePermissionModal.vue?vue&type=script&lang=js&"
export * from "./ChangePermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangePermissionModal.vue?vue&type=style&index=0&id=5ae56be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae56be2",
  null
  
)

export default component.exports